// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2K2aX","errorBadge":"styles_errorBadge__qGp8d","title":"styles_title__TDADj"};